import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { debounceTime, finalize, map, startWith, switchMap } from 'rxjs/operators';
import { CompanyService } from 'src/mocks/searchapi.company.service';
import { CompanyPageRequestDto } from 'src/portal/search-api/models/company-page-request-dto';
import { FacetDto } from 'src/portal/search-api/models/facet-dto';
import { GlobalSearchResultTypeEnum } from 'src/portal/search-api/models/global-search-result-type-enum';
import { SuggestService } from 'src/portal/search-api/services/suggest.service';

@Component({
  selector: 'search-filter-autocomplete-switch',
  templateUrl: './search-filter-autocomplete-switch.component.html',
  styleUrls: ['./search-filter-autocomplete-switch.component.scss']
})
export class SearchFilterAutocompleteSwitchComponent implements OnInit {

  @Input() label: string;
  @Input() placeholder: string;
  @Input() items: string[] = [];
  @Input() searchField: string;
  @Input() iconName: string;
  @Input() expanded: boolean = false;
  @Input() searhType: any = GlobalSearchResultTypeEnum.COMPANY;

  @Input() checkBoxLabelTrue: string = 'Yes';
  @Input() checkBoxLabelFalse: string = 'No';
  @Input() checkBoxEnable: boolean = false;
  @Input() checkBoxValue: boolean = false;

  @Output() itemsChange = new EventEmitter();
  @Output() checkBoxValueChange = new EventEmitter();

  @ViewChild('auto') auto: ElementRef;
  @ViewChild('input') input: ElementRef;

  addOnBlur = true;

  loading: boolean;
  inputControl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredItems: Observable<any[]>;

  constructor(
    private suggestService: SuggestService,
    private companyService: CompanyService
  ) {}

  ngOnInit() {
    this.setupFilteredItems();
  }



 private setupFilteredItems() {
  this.filteredItems = this.inputControl.valueChanges.pipe(
    startWith(''),
    debounceTime(300),
    switchMap((value) => {
      return this._filter(value);
    }),
  );
}

remove(item: string): void {
  const index = this.items.indexOf(item);

  if (index >= 0) {
    this.items.splice(index, 1);
    this.itemsChange.emit(this.items);
    this.setupFilteredItems();
  }
}

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!event.option) {
      return;
    }
    const value = event.option.value.name;

    if ((value || '').trim()) {
      this.items.push(event.option.viewValue);

      this.itemsChange.emit(event.option);
      this.inputControl.setValue('');
    }

  }

  private _filter(value: string): Observable<FacetDto[]> {
    this.loading = true;
    const filterValue = value.toLowerCase();
    if (this.searchField != 'companyName') {
      return this.suggestSearch(filterValue);
    } else {
      return this.companySearch(filterValue);
    }
  }

  public checkBoxChecked(value:boolean){
    this.checkBoxValue = value;
    this.checkBoxValueChange.emit(value);
    if(this.items.length > 0){
      this.itemsChange.emit(this.items);
    }

  }

  suggestSearch(filterValue): Observable<FacetDto[]> {
    return this.suggestService
      .suggest({
        entity: this.searhType,
        field: this.searchField,
        search: filterValue,
      })
      .pipe(
        map((result: FacetDto[]) => {
          const filteredResult = result?.filter((item: FacetDto) => {
            return !this.items.some((otherItem: string) => {
              return item.name.toLowerCase() === otherItem.toLowerCase();
            });
          });
          return filteredResult;
        }),
        finalize(() => (this.loading = false))
      );
  }

  companySearch(filterValue): Observable<any[]> {
    let body: CompanyPageRequestDto = {
      pageNumber: 0,
      pageSize: 10,
      filters: {
        search: filterValue,
        filterType: GlobalSearchResultTypeEnum.COMPANY,
      },
      sort: [],
    };
    return this.companyService.findCompanies({ body: body }).pipe(
      map((res) => res.content?.map((x: any) => ({
        id: x.id,
        name: x.companyName,
        website: x.website
      }))),
      map((res: FacetDto[]) => res?.filter(item =>
        !this.items.some(selectedItem => selectedItem.toLowerCase() === item.name.toLowerCase())
      )),
      finalize(() => (this.loading = false))
    );
  }
}
